import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { getTypeFromFileTypeName } from '@office-start/file-utility';
import { useLocStrings } from '@office-start/loc-service';
import { usePeopleCard } from '@office-start/people-card-service';
import { useRecommendedConfig } from '@office-start/recommended-config-service';
import RecommendedControl from '@office-start/recommended-control';
import { useRecommendedData } from '@office-start/recommended-data-service';
import { useVisualBackgroundEnabled } from '@office-start/visual-service';
import { useProvisionedWorkloads } from '@office-start/workloads-service';
import React, { useMemo } from 'react';
import { useRecommendedCallbacks } from './hooks/useRecommendedCallbacks';
import { useRecommendedDocumentActionsCreator } from './hooks/useRecommendedDocumentActionsCreator';
import { useRecommendedInstrumentation } from './hooks/useRecommendedInstrumentation';
export var RecommendedComponent = function (_a) {
    var _b;
    var fileType = _a.fileType, _c = _a.useFeedApi, useFeedApi = _c === void 0 ? false : _c, customConfig = _a.customConfig, _d = _a.showPeopleCard, showPeopleCard = _d === void 0 ? true : _d;
    var context = useOfficeComponentContext().data;
    var recommendedConfig = useRecommendedConfig().data;
    var locStrings = useLocStrings().data;
    var isVisualRefresh = useVisualBackgroundEnabled();
    var providerType = useFeedApi
        ? 'MicrosoftFeedApi'
        : 'RecommendedFilesApi';
    var workloads = useProvisionedWorkloads();
    var toDoWorkload = workloads === null || workloads === void 0 ? void 0 : workloads.find(function (workload) { return workload.Id === "ShellToDo" /* FirstPartyWorkloadIds.ToDo */; });
    var createActions = useRecommendedDocumentActionsCreator(providerType, locStrings);
    var recommendedDataResult = useRecommendedData(providerType, getTypeFromFileTypeName(fileType)).data;
    var featureGates = useFeatureGates().data;
    var meetingInsightsEnabled = useMemo(function () {
        var _a, _b;
        return (((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.meetingInsightsGates) === null || _b === void 0 ? void 0 : _b.meetingInsightsEnabled) || false);
    }, [featureGates]);
    var isStackedMeetingsEnabled = useMemo(function () {
        var _a, _b;
        return (((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.stackedUpcomingMeetingsGates) === null || _b === void 0 ? void 0 : _b.stackedUpcomingMeetingsEnabled) || false);
    }, [featureGates]);
    var callbacks = useRecommendedCallbacks(providerType, recommendedDataResult === null || recommendedDataResult === void 0 ? void 0 : recommendedDataResult.result, !!recommendedConfig &&
        (recommendedConfig.officeFeedControlEnabled ||
            recommendedConfig.officeFeedFlightEnabled) &&
        useFeedApi, (_b = toDoWorkload === null || toDoWorkload === void 0 ? void 0 : toDoWorkload.Url) !== null && _b !== void 0 ? _b : '');
    var documents = useMemo(function () {
        var _a;
        return (_a = recommendedDataResult === null || recommendedDataResult === void 0 ? void 0 : recommendedDataResult.result.documents) !== null && _a !== void 0 ? _a : [];
    }, [recommendedDataResult]);
    var PeopleCard = usePeopleCard(showPeopleCard);
    // TODO: Recommended zero state
    var canRender = !!(recommendedDataResult &&
        documents.length &&
        recommendedConfig &&
        locStrings &&
        context);
    useRecommendedInstrumentation({
        canRender: canRender,
        dataResult: recommendedDataResult,
        paintMarker: 'Paint_Recommended',
    });
    /* eslint-disable @typescript-eslint/no-non-null-assertion */
    return canRender ? (React.createElement(RecommendedControl, { PeopleCard: PeopleCard, carouselResources: locStrings.carouselResources, callbacks: callbacks, sectionTitle: locStrings.recommendedSectionResources.sectionTitle, documents: documents, moreActionsButtonAriaLabel: locStrings.edgeworthItemResources.moreActionsButtonAriaLabel, preferredCulture: context.preferredCulture, dateResources: locStrings.dateResources, customConfig: customConfig, createActions: createActions, isVisualRefresh: isVisualRefresh, isUseFeedApi: useFeedApi, recommendedSectionResources: locStrings.recommendedSectionResources, isStackedMeetingsEnabled: isStackedMeetingsEnabled, isMeetingInsightsEnabled: meetingInsightsEnabled })) : null;
};
//# sourceMappingURL=RecommendedComponent.js.map